module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"header":{"form":"Formulář","state":"Stav"}},"de":{"header":{"form":"Formular","state":"Status"}},"es":{"header":{"form":"Formulario","state":"Estado"}},"fr":{"header":{"form":"Formulaire","state":"État"}}}')
  delete Component.options._Ctor
}
